import React, { useState } from 'react';
import { AccountBalanceWallet, Close } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import moment from 'moment';
import { useEffect } from 'react';
import { wsGetAll } from 'services/WService';

function TabTransfer(props) {
  const { totalAmount, payWithDocuments } = props;
  const { payment, setPayment } = props;
  const { paymentMethod, setPaymentMethod } = props;

  const [accounts, setAccounts] = useState([]);

  async function listAccounts() {
    let res = await wsGetAll('pymt/transfer-accounts');
    setAccounts(res.data);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (paymentMethod === 'TR') {
      setPaymentMethod(null);
      return;
    }
    setPaymentMethod('TR');
    setPayment((payment) => ({ ...payment, TrsfrSum: totalAmount }));
  }

  useEffect(() => {
    listAccounts();

    let newPaymentData = { ...payment };
    if (payment.TrsfrDate === undefined) {
      newPaymentData.TrsfrDate = moment().format('YYYY-MM-DD');
    }

    if (payment.TrsfrRef === undefined) {
      newPaymentData.TrsfrRef = '';
    }

    if (payment.TrsfrSum === undefined) {
      newPaymentData.TrsfrRef = 0;
    }

    setPayment(newPaymentData);

    return () => {
      setAccounts([]);
    };
  }, []);

  useEffect(() => {
    if (payment.TrsfrSum === undefined) return;
    setPayment((payment) => ({ ...payment, TrsfrSum: totalAmount }));
  }, [totalAmount]);

  return (
    <GridContainer style={{ width: '100%' }}>
      {/* Campos */}
      <GridItem xs={12} lg={10}>
        <form id="formTR" onSubmit={handleSubmit}>
          <GridContainer>
            {/* TrsfrAcct */}
            <GridItem xs={12} sm={6} lg={3}>
              <FormControl fullWidth size="small" disabled={paymentMethod !== null}>
                <InputLabel>Cuenta de mayor</InputLabel>
                <Select
                  required
                  inputProps={{
                    name: 'TrsfrAcct',
                  }}
                  value={payment.TrsfrAcct || ''}
                  onChange={(e) => {
                    let TrsfrAcct = e.target.value;
                    setPayment((payment) => ({ ...payment, TrsfrAcct }));
                  }}
                >
                  {accounts.map((item, i) => {
                    return (
                      <MenuItem value={item.GLAccount} key={i}>
                        {`${!!item.City ? item.City + ' - ' : ''} ${!!item.GLAccount ? item.GLAccount + ' - ' : ''} ${item.BankName} - ${item.Branch}`}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
            {/* TrsfrDate */}
            <GridItem xs={12} sm={6} lg={3}>
              <TextField
                name="TrsfrDate"
                fullWidth
                label="Fecha de transferencia"
                type="date"
                value={payment.TrsfrDate || moment().format('YYYY-MM-DD')}
                onInput={(e) => {
                  let TrsfrDate = e.target.value;
                  setPayment((payment) => ({ ...payment, TrsfrDate }));
                }}
                required
                disabled={paymentMethod !== null}
              />
            </GridItem>
            {/* TrsfrRef */}
            <GridItem xs={12} sm={6} lg={3}>
              <TextField
                name="TrsfrRef"
                fullWidth
                label="Referencia"
                value={payment.TrsfrRef || ''}
                onInput={(e) => {
                  let TrsfrRef = e.target.value;
                  setPayment((payment) => ({ ...payment, TrsfrRef }));
                }}
                required
                disabled={paymentMethod !== null}
              />
            </GridItem>
            {/* TrsfrSum */}
            <GridItem xs={12} sm={6} lg={3}>
              <TextField
                name="TrsfrSum"
                fullWidth
                label="Monto a pagar"
                type="number"
                value={totalAmount || 0}
                onInput={(e) => {
                  let TrsfrSum = e.target.value;

                  if (!payWithDocuments) {
                    setPayment((payment) => ({ ...payment, TrsfrSum }));
                    return;
                  }

                  // Si el DocType no es Cliente, validar
                  if (payment.DocType !== 'C') {
                    if (TrsfrSum > totalAmount) {
                      setPayment((payment) => ({ ...payment, TrsfrSum: totalAmount }));
                      return;
                    }
                  }

                  setPayment((payment) => ({ ...payment, TrsfrSum }));
                }}
                inputProps={{
                  min: 0,
                  step: 0.0001,
                }}
                required
                disabled={paymentMethod !== null}
              />
            </GridItem>
          </GridContainer>
        </form>
      </GridItem>
      {/* Botón procesar */}
      <GridItem xs={12} lg={2}>
        <Button
          style={{ float: 'right' }}
          color={paymentMethod === 'TR' ? 'danger' : 'primary'}
          size="sm"
          form="formTR"
          type="submit"
        >
          {paymentMethod === 'TR' ? <Close /> : <AccountBalanceWallet />}
          {paymentMethod === 'TR' ? 'Quitar' : 'Agregar'}
        </Button>
      </GridItem>
    </GridContainer>
  );
}

export default TabTransfer;
